export default __webpack_public_path__ + "static/media/Gallery-2.7eadff69.JPG";